import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
} from '@tisa-group/cdk';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {UmpireMatchStats} from '@tisa-group/models';

@Injectable()
export class MatchStatsService implements CrudService<UmpireMatchStats> {
  constructor(readonly http: TisaUmpireHttpService) {}

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireMatchStats>> {
    return this.http
      .get(`/matches/${fetchIdentifier}/stats`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
